var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOnecom(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 258 32",
    xmlns: "http://www.w3.org/2000/svg",
    width: 2500,
    height: 310,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16 25a9 9 0 1 1 .001-18.001A9 9 0 0 1 16 25m0-25C7.16 0 0 7.16 0 16s7.16 16 16 16 16-7.16 16-16S24.84 0 16 0m39 0c-8.84 0-16 7.16-16 16v16h7V15.73C46.14 10.9 50.12 7 55 7a9 9 0 0 1 9 9v16h7V15.7C70.83 7 63.73 0 55 0m30.5 13c1.25-3.5 4.58-6 8.5-6s7.25 2.5 8.5 6zm24.5 3c0-8.84-7.16-16-16-16S78 7.16 78 16s7.16 16 16 16c6.52 0 12.13-3.9 14.62-9.5h-8.4c-1.6 1.55-3.8 2.5-6.22 2.5-4.1 0-7.56-2.75-8.65-6.5h24.46c.13-.8.2-1.65.2-2.5z",
    fill: "#3c3c3c"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M123 20c3.3 0 6 2.7 6 6s-2.7 6-6 6-6-2.7-6-6 2.7-6 6-6",
    fill: "#76b82a"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M152 7c2.58 0 4.9 1.08 6.54 2.8l4.95-4.94C160.57 1.86 156.5 0 152 0c-8.82 0-16 7.16-16 16s7.18 16 16 16c4.52 0 8.58-1.87 11.5-4.86l-4.96-4.95C156.9 23.9 154.58 25 152 25c-4.96 0-9-4.03-9-9s4.04-9 9-9m34 18a9 9 0 1 1 .001-18.001A9 9 0 0 1 186 25m0-25c-8.84 0-16 7.16-16 16s7.16 16 16 16 16-7.16 16-16-7.16-16-16-16m58 0c-4.18 0-7.94 1.83-10.5 4.74C230.94 1.84 227.18 0 223 0c-7.73 0-14 6.27-14 14v18h7V13.76A7.006 7.006 0 0 1 223 7c3.87 0 7 3.13 7 7v18h7V13.76A7.006 7.006 0 0 1 244 7c3.87 0 7 3.13 7 7v18h7V14c0-7.73-6.27-14-14-14",
    fill: "#3c3c3c"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOnecom);
export default __webpack_public_path__ + "static/media/one.com.21c1a03a4590c41957bfc1ecb2004853.svg";
export { ForwardRef as ReactComponent };